import React from 'react';
import { createIcon } from './create-icon';
import './icon-filters.scss';

export const IconFilters = createIcon(<div className="icon-filters" />);
